module.exports = __webpack_public_path__ + "e597d4f4760171b5141e60ad18bcdf94.png";